import { Component, OnInit } from '@angular/core';
import { AuthHandlerService } from 'src/app/auth/auth-handler.service';
import { MetaService } from 'src/app/shared/services/meta.service';

@Component({
  selector: 'app-failed',
  templateUrl: './failed.component.html',
  styleUrls: []
})
export class FailedComponent implements OnInit {

  constructor(
    private _authHandlerService: AuthHandlerService,
    private _metaService: MetaService,
  ) { }

  ngOnInit(): void {
    //this._authHandlerService.logoutIfInvalidAccount();
  }

}